const header = document.querySelector('.mega-menu-outer-shopify-wrapper');

// Mobile check
const isMobile = () => window.matchMedia('(max-width: 1120px)').matches;

// Function to update class
function updateScrolledClass() {
    if (isMobile()) {
        header.classList.add('is-scrolled');
    } else {
        const scrollPosition = window.scrollY;
        if (scrollPosition >= 30) {
            header.classList.add('is-scrolled');
        } else {
            header.classList.remove('is-scrolled');
        }
    }
}

// Initial check
updateScrolledClass();

// Run on scroll
window.addEventListener('scroll', updateScrolledClass);

// Run on resize to re-evaluate device type
window.addEventListener('resize', updateScrolledClass);



// document.addEventListener("DOMContentLoaded", () => {
                                                        
//     // Menu Horizontal slider
//     const inner_menu_scroll = document.querySelectorAll('.inner-menu-scroll');

//     inner_menu_scroll.forEach((menu) => {
//         let isDown = false;
//         let startX;
//         let scrollLeft;

//         menu.addEventListener('mousedown', (e) => {
//             isDown = true;
//             menu.classList.add('active');
//             startX = e.pageX - menu.offsetLeft;
//             scrollLeft = menu.scrollLeft;
//         });

//         menu.addEventListener('mouseleave', () => {
//             isDown = false;
//             menu.classList.remove('active');
//         });

//         menu.addEventListener('mouseup', () => {
//             isDown = false;
//             menu.classList.remove('active');
//         });

//         menu.addEventListener('mousemove', (e) => {
//             if(!isDown) return;
//             e.preventDefault();
//             const x = e.pageX - menu.offsetLeft;
//             const walk = (x - startX) * 3; //scroll-fast
//             menu.scrollLeft = scrollLeft - walk;
//         });
//     })
                                                        
// })